export default __webpack_public_path__ + "static/media/O-108.58945c9e.png";